import { ImageWithLoader } from '@/components/ui/image-with-loader';

import { Asset } from '../../../types';
import { getAssetUrl } from '../../../utils/asset-loader';

interface SingleAssetDisplayProps {
  asset: Asset;
  assetsBaseUrl: string;
}

export const SingleAssetDisplay = ({ asset, assetsBaseUrl }: SingleAssetDisplayProps) => {
  return (
    <ImageWithLoader
      src={getAssetUrl(asset, assetsBaseUrl)}
      alt={asset.title}
      className="h-full w-full object-contain p-2"
      containerClassName="w-full h-full"
      skeletonClassName="w-full h-full"
      loading="lazy"
    />
  );
};
